var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22882_61796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 4.5H3C1.35 4.5 0 5.85 0 7.5V28.5C0 30.15 1.35 31.5 3 31.5H33C34.65 31.5 35.985 30.15 35.985 28.5L36 7.5C36 5.85 34.65 4.5 33 4.5ZM12 9C14.49 9 16.5 11.01 16.5 13.5C16.5 15.99 14.49 18 12 18C9.51 18 7.5 15.99 7.5 13.5C7.5 11.01 9.51 9 12 9ZM21 27H3V25.5C3 22.5 9 20.85 12 20.85C15 20.85 21 22.5 21 25.5V27ZM26.775 21H28.86C29.1 21 29.31 21.105 29.46 21.3L31.11 23.475C31.335 23.775 31.305 24.195 31.035 24.45L28.995 26.49C28.725 26.76 28.275 26.79 27.99 26.55C26.295 25.11 25.035 23.175 24.42 20.985C24.15 20.04 24 19.035 24 18C24 16.965 24.15 15.96 24.42 15C25.035 12.795 26.295 10.875 27.99 9.435C28.29 9.18 28.725 9.225 28.995 9.495L31.035 11.535C31.305 11.805 31.335 12.225 31.11 12.51L29.46 14.685C29.325 14.88 29.1 14.985 28.86 14.985H26.775C26.445 15.93 26.25 16.935 26.25 17.985C26.25 19.035 26.445 20.055 26.775 21Z",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22882_61796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoNumber);
export default __webpack_public_path__ + "static/media/infoNumber.b0d8f1fb.svg";
export { ForwardRef as ReactComponent };